<template xmlns:v-clipboard="http://www.w3.org/1999/xhtml">
  <div id="app">

    <div class="header">
      <div class="info">
        <img class="img" src="@/assets/logo.png"/>
        <label class="title">词根词缀词典</label>
      </div>

      <div class="tabList">
<!--        <div v-for="(item, index) in tabList" class="item">-->
<!--          <label>{{ item }}</label>-->
<!--        </div>-->

        <div class="item" @click="btnHome">
          <label>首页</label>
        </div>
        <div class="item" @click="btnUi">
          <label>界面</label>
        </div>
        <div class="item" @click="btnDownload">
          <label>下载</label>
        </div>
        <div class="item" @click="btnAbout">
          <label>关于</label>
        </div>
      </div>
    </div>

    <div class="home" ref="home">
      <img class="bg" src="@/assets/dict_desk_bg.png"/>

      <div class="info">
        <label class="title">词根词缀帮助您快速记忆单词</label>
        <label class="desc">我们有专业的团队24小时维护，为您保驾护航，赶紧快来下载吧</label>

        <div class="func">
          <label class="btnDown" @click="btnDownload">下载APP</label>
          <label class="btnContact" @click="btnAbout">联系我们</label>
        </div>
      </div>

      <img src="@/assets/dict_desk_1.png" class="img"/>
<!--      <div class="iphone"><iframe src="https://bestcircler.com/h5/" class="img"></iframe></div>-->
    </div>

    <div class="ui" ref="ui">
      <label class="title">界面欣赏</label>
      <label class="desc">我们只截取了一小部分的界面，更多精彩界面，请到APP内自行体验</label>
      <div class="img">
        <img class="item" v-for="item in uiList" :src="item"/>
      </div>
    </div>

    <div class="download" ref="download">
      <label class="title">立即下载我们的APP，体验无限的可能性。</label>
      <label class="desc">下载过程中如有任何问题请联系我们的客服，我们全程为您提高免费服务</label>

      <div class="func">
        <div class="btn" @click="btnDownloadIOS">
          <img class="img" src="@/assets/icon_appstore.png">
          <label class="text">APP Store下载</label>
        </div>
        <div class="btn" @click="btnDownloadAndroid">
          <img class="img" src="@/assets/icon_android.png">
          <label class="text">Android 下载</label>
        </div>
      </div>
    </div>

    <div class="about" ref="about">
      <img class="bg" src="@/assets/footer_bg.png"/>

      <div class="info">
        <label class="title">词根词缀</label>
        <label class="desc">我们的专业团队时刻在岗，确保软件的正常运营和下载</label>
        <label class="weixin">微信号:tdq-pdd</label>
      </div>

      <img class="img" src="https://dict001.oss-cn-shanghai.aliyuncs.com/config/wx_service.jpeg">
    </div>
<!--    <div class="beian">备案号：苏ICP备19038863号</div>-->

  </div>
</template>

<script>

import constant from '@/js/constants.js'

export default {
  name: 'Desk',
  data() {
    return {
      tabList: [
        "首页",
        "界面",
        "下载",
        "关于"
      ],
      uiList: [
        "https://dict001.oss-cn-shanghai.aliyuncs.com/config/h5/dict_desk_2.png",
        "https://dict001.oss-cn-shanghai.aliyuncs.com/config/h5/dict_desk_3.png",
        "https://dict001.oss-cn-shanghai.aliyuncs.com/config/h5/dict_desk_4.png",
        "https://dict001.oss-cn-shanghai.aliyuncs.com/config/h5/dict_desk_5.png",
        "https://dict001.oss-cn-shanghai.aliyuncs.com/config/h5/dict_desk_6.png",
        "https://dict001.oss-cn-shanghai.aliyuncs.com/config/h5/dict_desk_7.png",
      ]
    }
  },
  created() {
  },

  mounted() {
  },

  methods: {

    btnHome() {
      this.$refs.home.scrollIntoView();
    },

    btnUi() {
      this.$refs.ui.scrollIntoView();
    },

    btnDownload() {
      this.$refs.download.scrollIntoView();
    },

    btnAbout() {
      this.$refs.about.scrollIntoView();
    },

    btnDownloadIOS() {
      window.location = constant.appIosUrl;
    },

    btnDownloadAndroid() {
      window.location = constant.appAndroidUrl;
    },
  },
}
</script>

<style lang="stylus">

body {
  margin: 0;
  padding: 0;
  background-color: #ffffff;
}

#app {
  width 100%
  display: flex;
  flex-direction: column;
  align-items: center;
}

.header {
  width 100%
  height 60px
  display flex
  flex-direction row
  align-items center
  background-color white
  top: 0
  position fixed
  z-index 10

  .info {
    display flex
    flex-direction row
    align-items center
    margin-left 10%

    .img {
      width 25px
      height 25px
    }

    .title {
      font-size 18px
      margin-left 20px
      color #333333
    }
  }

  .tabList {
    flex 1
    display flex
    flex-direction row
    align-items center
    justify-content center

    .item {
      width 70px
      font-size 12px
    }
  }
}


.home {
  width 100%
  height 600px
  display flex
  flex-direction row
  align-items center
  position relative

  .bg {
    top 0
    right 0
    position absolute
    width 700px
    z-index -1
  }

  .info {
    flex 1
    display flex
    flex-direction column
    align-items center

    .title {
      width 300px
      text-align left
      font-size 22px
    }

    .desc {
      width 300px
      font-size 12px
      color #999999
      margin-top 10px
    }
  }

  .func {
    display flex
    flex-direction row
    align-items center
    margin-top 40px

    .btnDown {
      width 120px
      height 36px
      text-align center
      line-height 36px
      background #DC79DA
      border-radius 40px
      color white
      font-size 12px
    }

    .btnContact {
      width 120px
      height 36px
      text-align center
      line-height 36px
      border blue solid 1.5px
      border-radius 40px
      color blue
      font-size 12px
      margin-left 20px
    }
  }

  .img {
    width 220px
    margin-right 22%
  }

  .iphone {
    width 350px
    height 500px
    margin-top 50px
    margin-right 22%
    background-image url(../../../assets/iphone.png)
    background-repeat no-repeat
    background-size: 350px 500px;

    .img {
      width 240px
      height 430px
      border 0 solid #333333
      margin-top 30px
      margin-left 50px
    }
  }
}


.ui {
  width 100%
  flex 1
  display flex
  flex-direction column
  align-items center

  .title {
    font-size 20px
    margin-top 40px
  }

  .desc {
    font-size 12px
    color #999999
    margin-top 15px
  }

  .img {
    width 100%
    height 420px
    display flex
    flex-direction row
    margin-top 40px
    overflow auto

    .item {
      width 200px
      margin-left 40px
    }
  }
}

.download {
  width 100%
  margin-top 60px
  flex 1
  display flex
  flex-direction column
  align-items center

  .title {
    font-size 20px
  }

  .desc {
    font-size 12px
    color #999999
    margin-top 15px
  }

  .func {
    display flex
    flex-direction row
    align-items center
    margin-top 40px

    .btn {
      width 220px
      height 44px
      display flex
      flex-direction row
      align-items center
      justify-content center
      background black
      border-radius 40px
      margin-left 30px
      margin-right 30px

      .img {
        width 30px
        height 30px
      }

      .text {
        color white
        font-size 12px
        text-align center
        margin-left 10px
      }
    }
  }
}

.about {
  width 100%
  display flex
  flex-direction row
  align-items center
  position relative
  margin-top 100px
  justify-content space-around
  padding-top 60px

  .bg {
    top 0
    right 0
    position absolute
    width 100%
    z-index -1
  }


  .info {
    width 300px
    display flex
    flex-direction column

    .title {
      font-size 20px
      margin-top 40px
    }

    .desc {
      font-size 12px
      color #333333
      margin-top 15px
    }

    .weixin {
      font-size 20px
      margin-top 20px
    }
  }

  .img {
    width 200px
    height 200px
  }
}

.beian {
  font-size 12px
  color #999999
  margin-top 40px
}
</style>



// WEBPACK FOOTER //
// src/pages/dict/desk/desk.vue